import { render, staticRenderFns } from "./WPMenu.vue?vue&type=template&id=2372fb4a"
import script from "./WPMenu.vue?vue&type=script&lang=ts"
export * from "./WPMenu.vue?vue&type=script&lang=ts"
import style0 from "./WPMenu.vue?vue&type=style&index=0&id=2372fb4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports